import { TABLE, TD, TH } from "@/components/tool-kit/styles";
import type { TruthTable } from "@/lib/tool-kit/algebra/logic";

/**
 * The truth table itself: inputs on the left, each sub-formula in turn, and the whole
 * formula's column picked out. A true value is bold so the pattern of a column can be
 * read at a glance, even in greyscale.
 */
export function TruthTableView({
  table,
  trueSymbol,
  falseSymbol,
  caption,
}: {
  table: TruthTable;
  trueSymbol: string;
  falseSymbol: string;
  caption: string;
}) {
  const show = (value: boolean) => (value ? trueSymbol : falseSymbol);
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-card">
      <table className={`${TABLE} text-center`}>
        <caption className="sr-only">{caption}</caption>
        <thead>
          <tr>
            {table.variables.map((name) => (
              <th
                className={`${TH} text-center font-mono`}
                key={name}
                scope="col"
              >
                {name}
              </th>
            ))}
            {table.columns.map((column, index) => (
              <th
                className={`${TH} whitespace-nowrap text-center font-mono ${
                  index === table.finalIndex
                    ? "border-l-2 border-l-primary bg-primary/5"
                    : ""
                }`}
                key={column.label}
                scope="col"
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row) => (
            <tr key={row.minterm}>
              {row.inputs.map((value, k) => (
                <td className={`${TD} font-mono`} key={table.variables[k]}>
                  {show(value)}
                </td>
              ))}
              {row.values.map((value, index) => (
                <td
                  className={`${TD} font-mono ${value ? "font-bold" : "text-muted-foreground"} ${
                    index === table.finalIndex
                      ? "border-l-2 border-l-primary bg-primary/5"
                      : ""
                  }`}
                  key={table.columns[index].label}
                >
                  {show(value)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
